// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"584":"322641ae","592":"de09dede","984":"3037cdd0"}[chunkId] + ".chunk.js";
};